import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  InputAdornment,
  CircularProgress
} from '@mui/material';

import {
  Email,
  Send
} from '@mui/icons-material';

const url_tempPassword = (process.env.REACT_APP_API_BASEURL || '') + '/api/tempPassword';

const TempPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error('Please enter your email address');
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(url_tempPassword, { email });
      
      toast.success('Temporary password sent to your email. Redirecting...');
      setTimeout(() => history.push('/changePassword'), 3000);
    } catch (err) {
      const errorMsg = err.response?.data || err.message;
      
      if (errorMsg === 'User not in database' || errorMsg === 'User not found') {
        toast.error('Email not found in our system');
      } else {
        toast.error(typeof errorMsg === 'string' ? errorMsg : 'Failed to send temporary password');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            borderRadius: 2,
            width: '100%',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
          }}
        >
          <Typography component="h1" variant="h4" align="center" sx={{ mb: 2 }}>
            Forgot Password
          </Typography>

          <Typography
            variant="body2"
            align="center"
            sx={{ mb: 4, color: 'text.secondary' }}
          >
            Enter your email address and we'll send you a temporary password.
          </Typography>

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email color="action" />
                  </InputAdornment>
                )
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={isLoading}
              sx={{
                mt: 3,
                mb: 2,
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 600,
                background: 'linear-gradient(90deg, #3f6fb0 0%, #4d8fc7 100%)',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(33, 150, 243, 0.3)'
                }
              }}
              endIcon={isLoading ? <CircularProgress size={20} /> : <Send />}
            >
              {isLoading ? 'Sending...' : 'Send Temporary Password'}
            </Button>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Typography
                component="a"
                href="#/sign-in"
                variant="body2"
                sx={{
                  color: 'primary.main',
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Back to Sign In
              </Typography>

              <Typography
                component="a"
                href="#/changePassword"
                variant="body2"
                sx={{
                  color: 'primary.main',
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Already have temp password?
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default TempPassword;